export default __webpack_public_path__ + "static/media/sticker-G.59206dd6.png";